import React, { useMemo } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import strings from "translate/language";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const PALETTE = ["#4466f2", "#0ea5e9", "#14b8a6", "#f59e0b", "#8b5cf6"];

const defaultOptions = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: "index",
    intersect: false,
  },
  plugins: {
    legend: {
      display: true,
      position: "top",
      align: "end",
      labels: {
        boxWidth: 12,
        boxHeight: 12,
        borderRadius: 3,
        useBorderRadius: true,
        color: "#64748b",
        font: { size: 12, weight: "500" },
        padding: 14,
      },
    },
    title: { display: false },
    tooltip: {
      backgroundColor: "#0f172a",
      titleColor: "#ffffff",
      bodyColor: "#e2e8f0",
      padding: 12,
      cornerRadius: 8,
      callbacks: {
        label(ctx) {
          const label = ctx.dataset?.label ? `${ctx.dataset.label}: ` : "";
          const value = ctx.parsed?.y;
          return `${label}${value ?? 0}`;
        },
      },
    },
  },
  scales: {
    x: {
      grid: { display: false },
      ticks: {
        color: "#64748b",
        font: { size: 11 },
        maxRotation: 0,
        autoSkip: true,
        maxTicksLimit: 12,
      },
      border: { display: false },
    },
    y: {
      beginAtZero: true,
      grace: "5%",
      grid: { color: "#eef2f7", drawBorder: false },
      ticks: { color: "#64748b", font: { size: 12 }, precision: 0 },
      border: { display: false },
    },
  },
};

const styleDatasets = (datasets = []) =>
  datasets.map((ds, i) => {
    const color = PALETTE[i % PALETTE.length];
    return {
      ...ds,
      backgroundColor: color,
      borderColor: color,
      borderWidth: 0,
      borderRadius: 3,
      borderSkipped: false,
      maxBarThickness: 22,
      categoryPercentage: 0.75,
      barPercentage: 0.9,
    };
  });

export function Bookingchart(props) {
  const { options = defaultOptions, labels = [], datasets } = props;
  const data = useMemo(
    () => ({
      labels,
      datasets: styleDatasets(
        datasets || [
          {
            label: strings.visitG,
            data: labels.map(() => 0),
          },
          {
            label: strings.registrationG,
            data: labels.map(() => 0),
          },
          {
            label: strings.appointmentG,
            data: labels.map(() => 0),
          },
          {
            label: strings.followupG,
            data: labels.map(() => 0),
          },
          {
            label: strings.bookingG,
            data: labels.map(() => 0),
          },
        ]
      ),
    }),
    [labels, datasets]
  );
  return <Bar options={options} data={data} />;
}
